import React from 'react'
import { withNamespaces } from 'react-i18next'

import i18n from 'Pods/Shared/I18n'
import Tabs from 'Pods/Shared/Tabs/Tabs'

function TestimonialTabs({ t }) {
  function getTabTitle(title, imgPath) {
    return (
      <div className="testimonial-tabs__tab-title u-text-center">
        <img src={imgPath} alt={title} />
      </div>
    )
  }

  function getTabContent(testimonial, author) {
    return (
      <div className="testimonial-tabs__tab-content u-text-center">
        <p className="testimonial">“{testimonial}”</p>
        <p className="author">- {author}</p>
        <div className="separator" />
      </div>
    )
  }

  return (
    <div className="testimonial-tabs">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="l-inner-large">
              <Tabs
                tabs={
                  t('testimonials', { returnObjects: true }).map((partner) => {
                    return {
                      title: getTabTitle(partner.title, require(`images/business/partners/${partner.slug}.png`)),
                      id: `${partner.slug}`,
                      contents: getTabContent(partner.testimonial, partner.author),
                    }
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withNamespaces('enterprise')(TestimonialTabs)
